export default {
  CAUTION: require("../../assets/icons/Caution.svg")
};
